import Commons from '../../../../Services/Common/Common';

export const M_FILE_BASIC_01_Schema = {
  mapper: {
    search1: {
      UserId: (context) => context.userInfo?.userid,
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd) || '',
    },
  },
};
